class FlixToastContainer extends HTMLElement {
  connectedCallback() {
    document.addEventListener('flix:toast', (e) => this._push(e.detail));
  }

  _push(detail) {
    const type = detail.type;
    const isError = type === 'error';
    // No copy to show means no toast: an untitled red box says nothing.
    if (isError && !this.dataset.i18nErrorTitle) return;
    const isAdd = type === 'add';
    const title = isError
      ? this.dataset.i18nErrorTitle
      : isAdd ? this.dataset.i18nAddTitle : this.dataset.i18nRemoveTitle;
    const iconBg = isError
      ? 'linear-gradient(135deg,#ff5b5b,#ff9b9b)'
      : isAdd ? 'linear-gradient(135deg,#1fb877,#5fe0a8)' : 'linear-gradient(135deg,#ff7a1a,#ffb259)';
    const iconSvg = isError
      ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
      : isAdd
      ? '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'
      : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';

    const toast = document.createElement('div');
    toast.className = 'flx-toast';
    toast.innerHTML =
      '<span class="flx-toast__icon" style="background:' + iconBg + '">' + iconSvg + '</span>' +
      '<div class="flx-toast__body"><div class="flx-toast__title">' + this._escape(title) + '</div>' +
      (detail.name ? '<div class="flx-toast__name">' + this._escape(detail.name) + '</div>' : '') + '</div>';
    this.appendChild(toast);
    setTimeout(() => toast.remove(), 2800);
  }

  _escape(s) {
    const d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }
}
customElements.define('flix-toast-container', FlixToastContainer);
